const defaultScrollThreshold = 5;

export enum ScrollType {
  Vertical = 'Vertical',
  Horizontal = 'horizontal',
}

interface TrackElementScrollOptionsProps {
  /** 滑动回调, 一次有效滑动：手指触碰 -> 滑动 -> 手指离开 */
  scrollCallback?: Function;

  /** 滚动container */
  containerElement?: HTMLElement;

  /** 是否监听有没有滑动到底部 */
  trackScrollToEnd?: boolean;

  /** 滑动到底部的回调 */
  scrollToEndCallBack?: Function;

  /** 滑动到底部阈值 */
  scrollThreshold?: number;
}

class TrackElementScroll {
  /** 需要监听滚动的element */
  ele: HTMLElement;

  /** 滚动方向 */
  type: ScrollType;
  scrollCallback?: Function;
  containerElement: HTMLElement;
  trackScrollToEnd?: boolean;
  scrollToEndCallBack?: Function;
  scrollThreshold: number;
  constructor(ele: HTMLElement, type: ScrollType, options?: TrackElementScrollOptionsProps) {
    this.ele = ele;
    this.type = type;
    this.scrollCallback = options?.scrollCallback;
    this.containerElement = options?.containerElement || this.ele.parentElement!;
    this.trackScrollToEnd = options?.trackScrollToEnd;
    this.scrollToEndCallBack = options?.scrollToEndCallBack;
    this.scrollThreshold = options?.scrollThreshold || defaultScrollThreshold;
    this.ele.addEventListener('touchstart', this.onTouchStart);
    this.trackScrollToEnd && this.containerElement?.addEventListener('scroll', this.onceScrollToEnd);
  }

  onTouchStart = () => {
    const containerElement = this.containerElement!;
    let hasMoved = false;
    const { scrollTop: startScrollTop, scrollLeft: startScrollLeft, scrollHeight, offsetHeight, scrollWidth, offsetWidth } = containerElement;

    const onTouchMove = () => {
      if (this.type === ScrollType.Vertical) {
        hasMoved = containerElement.scrollTop !== startScrollTop && scrollHeight !== offsetHeight;
      } else if (this.type === ScrollType.Horizontal) {
        hasMoved = containerElement.scrollLeft !== startScrollLeft && scrollWidth !== offsetWidth;
      }
    };

    const onTouchEnd = () => {
      hasMoved && this.scrollCallback?.();

      window.removeEventListener('touchmove', onTouchMove);
      window.removeEventListener('touchend', onTouchEnd);
    };

    window.addEventListener('touchmove', onTouchMove);
    window.addEventListener('touchend', onTouchEnd);
  };

  onceScrollToEnd = () => {
    const { scrollHeight, offsetHeight, scrollWidth, offsetWidth, scrollTop, scrollLeft } = this.containerElement!;

    const scrollToEnd = () => {
      this.scrollToEndCallBack?.();
      this.containerElement?.removeEventListener('scroll', this.onceScrollToEnd);
    };

    if (this.type === ScrollType.Vertical) {
      if (scrollHeight - offsetHeight - scrollTop <= this.scrollThreshold) {
        scrollToEnd();
      }
    } else if (this.type === ScrollType.Horizontal) {
      if (scrollWidth - offsetWidth - scrollLeft <= this.scrollThreshold) {
        scrollToEnd();
      }
    }
  };

  destroy = () => {
    this.ele.removeEventListener('touchstart', this.onTouchStart);
    this.trackScrollToEnd && this.containerElement?.removeEventListener('scroll', this.onceScrollToEnd);
  };
}

export class ElementScrollTrackManage {
  elementArray: TrackElementScroll[];
  constructor() {
    this.elementArray = [];
  }

  addTrack(ele: HTMLElement, type: ScrollType, options?: TrackElementScrollOptionsProps) {
    this.elementArray.push(new TrackElementScroll(ele, type, options));
  }

  removeAllTrack() {
    this.elementArray.forEach(item => {
      item.destroy();
    });
  }
}
